import { render } from "./pagination.vue?vue&type=template&id=2f38420e"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/shared/list/pagination/pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f38420e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f38420e', __exports__)) {
    console.log('reload')
    api.reload('2f38420e', __exports__)
  }
  
  module.hot.accept("./pagination.vue?vue&type=template&id=2f38420e", () => {
    console.log('re-render')
    api.rerender('2f38420e', render)
  })

}


export default __exports__